import React from "react";
import CustomAppBar from "../../components/AppBar";
// import { Container, Grid, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  CustomChartsTitle,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { Grid, Box, Card, Container } from "@mui/material";
import CustomTransactionTable from "../../components/Custom/CustomTransactionTable";

const VerifierDashboard = () => {
  const { t } = useTranslation();
  const columns = [
    { label: "Farmer Name", field: "farmerName" },
    { label: "Crop Name", field: "cropName" },
    { label: "Area", field: "area" },
    { label: "Program", field: "program" },
    { label: "Action", field: "action" },
  ];

  const data = [
    // {
    //   farmerName: "Kisan Patil",
    //   cropName: "Rice",
    //   area: "20 Acre",
    //   program: "Stubble ",
    // },
  ];

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Box sx={{ marginTop: "20px" }}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <CustomDashboardCard title={t("TOTAL CLAIMS")} data={0} />
                </Grid>
                <Grid item xs={6}>
                  <CustomDashboardCard title={t("PENDING REQUEST")} data={0} />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "20px" }}>
              <CustomChartsTitle>{t("Current Requests")}</CustomChartsTitle>
              <Grid container spacing={1} sx={{ padding: "10px 0" }}>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("New Request 0")}</CustomValue>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("Pending Request 0")}</CustomValue>
                  </Card>
                </Grid>
              </Grid>
            </Box>

            <Box>
              <Grid item xs={12} height="150px">
                <CustomTransactionTable columns={columns} data={data} />
              </Grid>
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default VerifierDashboard;
